var styleDataHash = '5c5253a0';  
export const injectCss = (() => {
  var css = `.s59JF{--shimmer-base-color:#f5f5f5;background-color:var(--shimmer-base-color);pointer-events:none;z-index:1}.M2DHE,.s59JF{inset:0;position:absolute}.M2DHE{overflow:hidden}.M2DHE:after{animation:pjW0m 1s linear infinite;background:linear-gradient(90deg,transparent,hsla(0,0%,100%,.3),transparent 50%);bottom:0;content:"";left:0;position:absolute;right:0;top:0;transform:translateX(-100%)}@keyframes pjW0m{to{transform:translateX(100%)}}.BTOf2{bottom:12px;left:50%;position:absolute;transform:translateX(-50%);z-index:2}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "overlay": "s59JF",
  "shimmer": "M2DHE",
  "layout-shimmer": "pjW0m",
  "label": "BTOf2"
};